var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vue-tel-input',{model:{value:(_setup._value),callback:function ($$v) {_setup._value=$$v},expression:"_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }